import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { Container, LeftBox } from './SqueezeDivider.style';

export const SqueezeDivider = () => (
  <Container>
    <LeftBox />
    <StaticImage
      src="../images/squeeze-divider.png"
      alt=""
      layout="fixed"
      height={75}
    />
  </Container>
);
